/**
 * This file is generated by `pnpm codegen` from the OpenAPI spec, DO NOT EDIT.
 */

import makeMutationHook from 'core/types/makeMutationHook'
import makeQueryHook from 'core/types/makeQueryHook'
import * as operations from 'core/types/operations'

export const useInternalListContacts = makeQueryHook(
  operations.internalListContacts,
)

export const useInternalListContactsForBorrower = makeQueryHook(
  operations.internalListContactsForBorrower,
)

export const useInternalCreateContactForBorrower = makeMutationHook(
  operations.internalCreateContactForBorrower,
)

export const useInternalGetContactForBorrower = makeQueryHook(
  operations.internalGetContactForBorrower,
)

export const useInternalUpdateContactForBorrower = makeMutationHook(
  operations.internalUpdateContactForBorrower,
)

export const useInternalDeleteContact = makeMutationHook(
  operations.internalDeleteContact,
)

export const useInternalCloneContact = makeMutationHook(
  operations.internalCloneContact,
)

export const useListContactsForBorrower = makeQueryHook(
  operations.listContactsForBorrower,
)

export const useCreateContactForBorrower = makeMutationHook(
  operations.createContactForBorrower,
)

export const useGetContactForBorrower = makeQueryHook(
  operations.getContactForBorrower,
)

export const useUpdateContactForBorrower = makeMutationHook(
  operations.updateContactForBorrower,
)

export const useDeleteContact = makeMutationHook(operations.deleteContact)

export const useCloneContact = makeMutationHook(operations.cloneContact)
